import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateShopperLabelText: {
    defaultMessage: 'Rate Shopper:',
    id: 'CVDWnJ',
    description: 'Rate shopper label text',
  },
  serviceHeaderText: {
    defaultMessage: 'Service',
    id: 'fiFm8D',
    description: 'Service header text',
  },
  totalCostHeaderText: {
    defaultMessage: 'Cost',
    id: 'FoFQ3U',
    description: 'Total cost header text',
  },
  deliveryDateHeaderText: {
    defaultMessage: 'Delivery Date',
    id: '+BstKQ',
    description: 'Delivery date header text',
  },
  showMoreLinkText: {
    defaultMessage: 'show more',
    id: 'twWidU',
    description: 'Show more link text',
  },
  showLessLinkText: {
    defaultMessage: 'show less',
    id: 'SairTK',
    description: 'Show less link text',
  },
});
